interface GradientTitleProps {
  children: React.ReactNode;
  className?: string;
  useH1?: boolean;
}

export const GradientTitle: React.FC<GradientTitleProps> = ({ 
  children, 
  className = '',
  useH1 = true
}) => {
  const baseClassNames = `text-4xl font-bold bg-gradient-to-r from-orange-600 via-pink-600 to-red-600 
    bg-clip-text text-transparent ${className}`;
    
  return useH1 ? (
    <h1 className={baseClassNames}>
      {children}
    </h1>
  ) : (
    <h2 className={baseClassNames}>
      {children}
    </h2>
  );
}; 